import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAddIcon from 'material-ui/svg-icons/content/add';

class SpeedDial extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            open: false
        };
        this.handleToggle = this.handleToggle.bind(this);
    }

    handleToggle() {
        this.setState({ open: !this.state.open });
    }

    render() {
        const coverStyle = {height: (this.state.open ? window.innerHeight + 'px' : 0)};
        const actionsStyle = {top: this.state.open ? `${this.props.actions.length * -76}px` : '100px'};
        const actionButtons = this.props.actions.map((action, index) => {
            const delay = (30 * (this.state.open ? (this.props.actions.length - index) : index));
            const transitionStyle = { transitionDelay: `${delay}ms` };

            return (
                <div className="action" key={index}>
                    <div className="tooltip" style={transitionStyle}>
                        {action.label}
                    </div>
                    <div className="button" style={transitionStyle}>
                        <Link to={action.link}>
                            <FloatingActionButton >
                                {action.icon || <ContentAddIcon />}
                            </FloatingActionButton>
                        </Link>
                    </div>
                </div>
            );
        }, this);

        return (
            <div className={`speed-dial ${this.state.open ? 'opened' : 'closed'}`}>
                <div className="cover" style={coverStyle} onClick={this.handleToggle} />
                <div className="container">
                    <div className="actions" style={actionsStyle}>
                        {actionButtons}
                    </div>
                </div>
                <FloatingActionButton onMouseUp={this.handleToggle} >
                    <ContentAddIcon />
                </FloatingActionButton>
            </div>
        );
    }
}

SpeedDial.propTypes = {
    actions:    PropTypes.arrayOf(
        PropTypes.shape({
            label:      PropTypes.string.isRequired,
            link:       PropTypes.string,
            icon:       PropTypes.object
        })
    )
};

export default SpeedDial;
